import { BoxList } from "components/boxes/BoxList/BoxList";

export const Boxes = () => {

    return (
        <>
            <BoxList/>
        </>)
}
